/**
 * Document-grid size / uploader values must survive the API returning PascalCase
 * keys, numeric strings, or a mix of both. A strict `typeof === 'number'` check
 * leaves File Size and Uploaded By blank.
 */

type DocumentRow = Record<string, unknown> | null | undefined;

const FILE_SIZE_KEYS = ['fileSizeKB', 'FileSizeKB', 'fileSizeKb'] as const;
const UPLOADED_BY_KEYS = [
    'uploadedByFullName',
    'UploadedByFullName',
    'uploadedBy',
    'username',
    'userName',
    'Username',
] as const;
const ROLE_ID_KEYS = ['uploadedByRoleId', 'UploadedByRoleId'] as const;

export function readNumericField(row: DocumentRow, keys: readonly string[]): number | null {
    if (!row) return null;
    for (const key of keys) {
        const value = row[key];
        if (typeof value === 'number' && Number.isFinite(value)) return value;
        if (typeof value === 'string' && value.trim() !== '') {
            const parsed = Number(value);
            if (Number.isFinite(parsed)) return parsed;
        }
    }
    return null;
}

export function readStringField(row: DocumentRow, keys: readonly string[]): string {
    if (!row) return '';
    for (const key of keys) {
        const value = row[key];
        if (typeof value === 'string' && value.trim()) return value.trim();
    }
    return '';
}

export function formatFileSizeKb(row: DocumentRow): string {
    const kb = readNumericField(row, FILE_SIZE_KEYS);
    return kb == null ? '-' : `${kb} KB`;
}

export function readUploadedByName(row: DocumentRow): string {
    return readStringField(row, UPLOADED_BY_KEYS) || '-';
}

export function readUploadedByRoleId(row: DocumentRow): number | undefined {
    const roleId = readNumericField(row, ROLE_ID_KEYS);
    return roleId == null ? undefined : roleId;
}
